<template>
  <li class="flex items-center justify-between bg-gray-700 p-4 mb-4 rounded-lg">
    <div>
      <p class="font-semibold">
        <span v-for="(text, index) in h1" :key="'h1-' + index">
          {{ text }}<br v-if="index < h1.length - 1" />
        </span>
      </p>
      <p class="text-gray-400">
        <span v-for="(text, index) in h2" :key="'h2-' + index">
          {{ text }}<br v-if="index < h2.length - 1" />
        </span>
      </p>
    </div>
    <div class="flex space-x-1">
      <button
        v-for="(action, index) in actions"
        :key="'action-' + index"
        :class="action.iconColor"
        class="hover:bg-blue-600 text-white px-3 py-1 rounded-lg font-small"
        @click="action.onClick(data)"
        :title="action.tooltip || ''"
      >
        <i :class="action.icon"></i>
      </button>
    </div>
  </li>
</template>


<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    h1: {
      type: Array,
      required: true,
    },
    h2: {
      type: Array,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
  },
};
</script>
